import script from "./ChatMySharesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMySharesModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatMySharesModal.vue?vue&type=style&index=0&id=0b467b74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b467b74"]])

export default __exports__